import styled from 'styled-components';  

export const ModalTile = styled.h1`
     font-size: 25px;
    line-height: 33px;
    letter-spacing: 0px;
    color: #33A7AE;
    margin-bottom: 0;
    font-weight: bold;
`;

export const ModalButton = styled.div`
 text-align: center;
 margin-top: 13px;
   button.btn.btn-primary {
        background: #01606F;
        border: none;
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 9px 36px;
        transition: all 0.5s;
        border-radius: 10px;
        box-shadow: 3px 5px 20px #00000033;
      &:hover{
       background: #FFD495 !important;
        color: #333333 !important;
        transition: all 0.5s;
      }  
}
`;
